export const initialState = {
    patientDiscontinuationForm: {
        pharmacyName: null,
        patientDmsNumber: null,
        patientFirstName: null,
        patientLastName: null,
        dateDenzapineStopped: null,
        discontinuation: null,
        bloodMonitoringDate: null,
        printName: null,
        signature: null,
        date: null,
    },
    patientTransferFormFromBrandToDenzapine: {
        transferringDenzapine: null,
        patientUseType: null,
        dateOfTransfer: null,
        bloodKits: null,
        patientFirstName: null,
        patientLastName: null,
        dateOfBirth: null,
        monitoringFrequency: null,
        race: null,
        otherRace: null,
        ztasNumber: null,
        nameOfPrescriber: null,
        gmcNumber: null,
        prescriberAddress: null,
        prescriberEmailAddress: null,
        prescriberTelephoneNumber: null,
        nameOfPharmacy: null,
        pharmacyAddress: null,
        pharmacyTelephoneNumber: null,
        centreAddress: null,
        patientType: null,
        inpatientWard: null,
        centrePhoneNumber: null,
        neutropenia: null,
        redStatus: null,
        beningEthnicNeutropenia: null,
        treatmentResistantSchizophrenia: null,
        parkinsonDisease: null,
        diagnosisDetails: null,
        contraindicationsToClozapine: null,
        contraindicationsToClozapineDetails: null,
        boneMarrowFunction: null,
        patientOutsideOfUK: null,
        additionalInformation: null,
        consultantPsychiatristName: null,
        signature: null,
        date: null,
        gender: null,
    },
    pharmacyRegistrationForm: {
        hospitalName: null,
        pharmacySiteName: null,
        pharmacyAddress: null,
        pharmacyPhoneNumber: null,
        pharmacyEmail: null,
        responsiblePharmacist: null,
        pharmacistPhoneNumber: null,
        pharmacistEmail: null,
        technicianName: null,
        technicianPhoneNumber: null,
        technicianEmail: null,
        outOfHoursContactName: null,
        otherContacts: null,
        signature: null,
        date: null,
    },
    patientRegistrationForm: {
        patientUseType: null,
        proposedDateOfRegistration: null,
        patientFirstName: null,
        patientLastName: null,
        dateOfBirth: null,
        race: null,
        otherRace: null,
        gender: null,
        history: null,
        previousBrand: null,
        dispensingPharmacy: null,
        pharmacyAddress: null,
        pharmacyPhoneNumber: null,
        pharmacyEmail: null,
        nameOfPrescriber: null,
        gmcNumber: null,
        prescriberEmailAddress: null,
        patientType: null,
        wardAddress: null,
        wardContactName: null,
        wardTelephoneNumber: null,
        wardEmail: null,
        nameOfSite: null,
        clinicAddress: null,
        clinicContactName: null,
        clinicPhoneNumber: null,
        clinicEmailAddress: null,
        neutropenia: null,
        redStatus: null,
        beningEthnicNeutropenia: null,
        treatmentResistantSchizophrenia: null,
        parkinsonDisease: null,
        diagnosisDetails: null,
        contraindicationsToClozapine: null,
        contraindicationsToClozapineDetails: null,
        boneMarrowFunction: null,
        patientOutsideOfUK: null,
        antipsychotics: null,
        specifyAntipsychotics: null,
        dateOfBaselineBloodTest: null,
        whiteBloodCellCount: null,
        neutrophilCount: null,
        plateletCount: null,
        patientBarcodeLabels: null,
        otherBarcodeLabels: null,
        additionalInformation: null,
        consultantPsychiatristName: null,
        signature: null,
        date: null,
    },
    prescriberRegistrationForm: {
        prescriberFirstName: null,
        prescriberLastName: null,
        prescriberAddress: null,
        prescriberPhone: null,
        prescriberEmail: null,
        prescriberMobilePhoneNumber: null,
        gmcNumber: null,
        gmcSpecialistRegister: null,
        healthcareProfessional: null,
        signature: null,
        date: null,
    },
    websiteUserRegistrationForm: {
        jobPosition: null,
        userFirstName: null,
        userLastName: null,
        dispensingPharmacy: null,
        address: null,
        telephoneNumber: null,
        emailAddress: null,
        userAccessLevel: null,
        approverName: null,
        signature: null,
        date: null,
        approverEmail: null,
        approverPhoneNumber: null,
    },
    offLabelAgreementForm: {
        patientFirstName: null,
        patientLastName: null,
        dateOfBirth: null,
        dms: null,
        offLabelUseReasons: null,
        datesOfTravel: null,
        bloodTestBeforeHoliday: null,
        bloodTestBeforeHolidayDate: null,
        bloodTestReturnDate: null,
        additionalDaysInTotal: null,
        reasonForNoAttendAtBloodTest: null,
        nextBloodTestDate: null,
        offLicenceDays: null,
        printName: null,
        hospitalName: null,
        signature: null,
        date: null,
    },
    reChallengeRequestForm: {
        patientDmsNumber: null,
        patientFirstName: null,
        patientLastName: null,
        dateOfBirth: null,
        prohibitedFromReceivingClozapine: null,
        printName: null,
        signature: null,
        date: null,
    },
    patientBulkTransferFormBrandToDenzapineApprovalForm: {
        clozaril: null,
        zaponex: null,
        tablets: null,
        suspension: null,
        nameOfPrescriber: null,
        proposedDateOfTransfer: null,
        additionalInformation: null,
        consultantName: null,
        signature: null,
        date: null,
    },
};
const SecureSignForms = {
    namespaced: true,
    state: {
        patientDiscontinuationForm: initialState.patientDiscontinuationForm,
        pharmacyRegistrationForm: initialState.pharmacyRegistrationForm,
        patientTransferFormFromBrandToDenzapine: initialState.patientTransferFormFromBrandToDenzapine,
        patientRegistrationForm: initialState.patientRegistrationForm,
        prescriberRegistrationForm: initialState.prescriberRegistrationForm,
        websiteUserRegistrationForm: initialState.websiteUserRegistrationForm,
        offLabelAgreementForm: initialState.offLabelAgreementForm,
        reChallengeRequestForm: initialState.reChallengeRequestForm,
        patientBulkTransferFormBrandToDenzapineApprovalForm:
            initialState.patientBulkTransferFormBrandToDenzapineApprovalForm,
        errorMessages: {
            patientDiscontinuationForm: {
                pharmacyName: [],
                patientDmsNumber: [],
                patientFirstName: [],
                patientLastName: [],
                dateDenzapineStopped: [],
                discontinuation: [],
                bloodMonitoringDate: [],
                printFirstName: [],
                printLastName: [],
                signature: [],
                date: [],
            },
            pharmacyRegistrationForm: {
                hospitalName: [],
                pharmacySiteName: [],
                pharmacyAddress: [],
                pharmacyPhoneNumber: [],
                pharmacyEmail: [],
                responsiblePharmacist: [],
                pharmacistPhoneNumber: [],
                pharmacistEmail: [],
                technicianName: [],
                technicianPhoneNumber: [],
                technicianEmail: [],
                outOfHoursContactName: [],
                otherContacts: [],
                signature: [],
                date: [],
            },
            patientTransferFormFromBrandToDenzapine: {
                transferringDenzapine: [],
                patientUseType: [],
                dateOfTransfer: [],
                bloodKits: [],
                patientFirstName: [],
                patientLastName: [],
                dateOfBirth: [],
                monitoringFrequency: [],
                race: [],
                otherRace: [],
                ztasNumber: [],
                nameOfPrescriber: [],
                gmcNumber: [],
                prescriberAddress: [],
                prescriberEmailAddress: [],
                prescriberTelephoneNumber: [],
                nameOfPharmacy: [],
                pharmacyAddress: [],
                pharmacyTelephoneNumber: [],
                centreAddress: [],
                patientType: [],
                inpatientWard: [],
                centrePhoneNumber: [],
                neutropenia: [],
                redStatus: [],
                beningEthnicNeutropenia: [],
                treatmentResistantSchizophrenia: [],
                parkinsonDisease: [],
                diagnosisDetails: [],
                contraindicationsToClozapine: [],
                contraindicationsToClozapineDetails: [],
                boneMarrowFunction: [],
                patientOutsideOfUK: [],
                additionalInformation: [],
                consultantPsychiatristName: [],
                signature: [],
                date: [],
            },
            patientRegistrationForm: {
                patientUseType: [],
                proposedDateOfRegistration: [],
                patientFirstName: [],
                patientLastName: [],
                dateOfBirth: [],
                race: [],
                otherRace: [],
                gender: [],
                history: [],
                previousBrand: [],
                dispensingPharmacy: [],
                pharmacyAddress: [],
                pharmacyPhoneNumber: [],
                pharmacyEmail: [],
                nameOfPrescriber: [],
                gmcNumber: [],
                prescriberEmailAddress: [],
                patientType: [],
                wardAddress: [],
                wardContactName: [],
                wardTelephoneNumber: [],
                wardEmail: [],
                nameOfSite: [],
                clinicAddress: [],
                clinicContactName: [],
                clinicPhoneNumber: [],
                clinicEmailAddress: [],
                neutropenia: [],
                redStatus: [],
                beningEthnicNeutropenia: [],
                treatmentResistantSchizophrenia: [],
                parkinsonDisease: [],
                diagnosisDetails: [],
                contraindicationsToClozapine: [],
                contraindicationsToClozapineDetails: [],
                boneMarrowFunction: [],
                patientOutsideOfUK: [],
                antipsychotics: [],
                specifyAntipsychotics: [],
                dateOfBaselineBloodTest: [],
                whiteBloodCellCount: [],
                neutrophilCount: [],
                plateletCount: [],
                patientBarcodeLabels: [],
                otherBarcodeLabels: [],
                additionalInformation: [],
                consultantPsychiatristName: [],
                signature: [],
                date: [],
            },
            prescriberRegistrationForm: {
                prescriberFirstName: [],
                prescriberLastName: [],
                prescriberAddress: [],
                prescriberPhone: [],
                prescriberEmail: [],
                prescriberMobilePhoneNumber: [],
                gmcNumber: [],
                gmcSpecialistRegister: [],
                healthcareProfessional: [],
                signature: [],
                date: [],
            },
            websiteUserRegistrationForm: {
                jobPosition: [],
                userFirstName: [],
                userLastName: [],
                dispensingPharmacy: [],
                address: [],
                telephoneNumber: [],
                emailAddress: [],
                userAccessLevel: [],
                approverName: [],
                signature: [],
                date: [],
            },
            offLabelAgreementForm: {
                patientFirstName: [],
                patientLastName: [],
                dateOfBirth: [],
                dms: [],
                offLabelUseReasons: [],
                datesOfTravel: [],
                bloodTestBeforeHoliday: [],
                bloodTestBeforeHolidayDate: [],
                bloodTestReturnDate: [],
                additionalDaysInTotal: [],
                reasonForNoAttendAtBloodTest: [],
                nextBloodTestDate: [],
                offLicenceDays: [],
                printName: [],
                signature: [],
                date: [],
            },
            reChallengeRequestForm: {
                patientDmsNumber: [],
                patientFirstName: [],
                patientLastName: [],
                dateOfBirth: [],
                prohibitedFromReceivingClozapine: [],
                printName: [],
                signature: [],
                date: [],
            },
            patientBulkTransferFormBrandToDenzapineApprovalForm: {
                clozaril: [],
                zaponex: [],
                tablets: [],
                suspension: [],
                nameOfPrescriber: [],
                proposedDateOfTransfer: [],
                additionalInformation: [],
                consultantName: [],
                signature: [],
                date: [],
            },
        },
    },
    mutations: {
        SET_FORM_PROPERTY(state, data) {
            _.set(state, data.property, data.value);
        },
        SET_ERROR_MESSAGE(state, data) {
            _.set(state.errorMessages, data.property, data.value);
        },
        RESET_FORM_PROPERTY_ERROR(state, data) {
            _.set(state.errorMessages, data.property, data.value);
        },
    },
    actions: {
        updateProperty({ commit }, data) {
            commit('SET_FORM_PROPERTY', data);
        },
        resetPropertyError({ commit }, data) {
            commit('RESET_FORM_PROPERTY_ERROR', data);
        },
    },
};
export default SecureSignForms;
